module.exports = __webpack_public_path__ + "img/lecture_online1.1cf2f72b.png";